import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.appBar,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space24,
    padding: "16px 24px 20px 24px",
    paddingBottom: theme.spacing.space20,
    background:
      "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.60) 71.63%, rgba(0, 0, 0, 0.00) 100%)",
    [BreakPointDesktop]: {
      display: "none",
    },
  },
  item: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 48,
    height: 48,
    borderRadius: theme.radius.small,
    background: "rgba(255, 255, 255, 0.20)",
    backdropFilter: "blur(25px)",
    cursor: "pointer",
    transition: "background 0.2s ease",
  },
  itemActive: {
    background: theme.colors.Primary,
  },
  selected: {
    position: "relative",
    cursor: "pointer",
    pointerEvents: "auto",
    zIndex: 0,
    borderRadius: theme.spacing.space8,
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      boxSizing: "border-box",
      pointerEvents: "none",
      zIndex: 1,
      borderRadius: theme.spacing.space12,
      padding: 2,
      margin: -4,
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      backgroundImage:
        "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 20%, rgba(255, 255, 255, 0.2) 55%, rgba(255, 255, 255, 0.2) 100%, rgba(255, 255, 255, 0.5) 80%, rgba(255, 255, 255, 0.9) 100%)",
      WebkitMask:
        "linear-gradient(#000 0 0) padding-box, linear-gradient(#000 0 0) content-box",
      WebkitMaskComposite: "xor",
      mask: "linear-gradient(#000 0 0) padding-box, linear-gradient(#000 0 0) content-box",
      maskComposite: "exclude",
      transition: "padding 0.3s ease, margin 0.3s ease, opacity 0.3s ease",
    },
  },
}));
